// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import Vuex from 'vuex'
Vue.use(Vuex)
import Resource from 'vue-resource'
Vue.use(Resource)

import './assets/js/adaptation'
import './assets/js/prototype'

import './components/iconfont/iconfont.css'
import './assets/iconfont/iconfont.css'

import { sync } from 'vuex-router-sync'
import FastClick from 'fastclick'
import  './assets/js/filter'
import  './assets/js/directive'
import axios from 'axios'

import './assets/components/loading/loading'
import {SessionStore,Cookie,Bridge,getPlatform,Authentication} from './utils'
import {domOnLoad} from  './utils/utils'
import {API_ROOT,WECHAT_APPID,API_AI} from './config/const'

/*
测试：http://ft1m.ytgrading.com
预发：http://prem.ytgrading.com
正式：http://m.ytgrading.com
*/


const debug = process.env.NODE_ENV != 'production';

if (debug) {
  var baseURL = API_AI + '/';
} else {
  var baseURL = API_AI + '/';
}


var instance = axios.create({
  baseURL: baseURL,
});




// 添加请求拦截器
instance.interceptors.request.use(config => {
      let appId = Cookie.get('appId') ||   'fKhnk3UwbjhLP5NuFNQm5W';
      let appKey = Cookie.get('appKey') ||   '9dbe75e0-d10a-55a5-b232-ecd60a9f60be';
      let deviceId = Cookie.get('deviceId') || 'a7db4c9407af622a';
      let authorization = Authentication(appId, appKey, deviceId, config.method, '/' + config.url);
      config.headers['X-Zhao-AppId'] = appId;
      config.headers['X-Zhao-DeviceId'] = deviceId;
      config.headers['X-Zhao-UserId'] = Cookie.get('userId') ||  '';
      config.headers['X-Zhao-OSInfo'] = '{"os":"h5"}';
      config.headers['Authorization'] = authorization;
      return config;

},
err => {
    return Promise.reject(err);
});


// 添加响应拦截器
instance.interceptors.response.use(function (response) {

  // 对响应数据做点什么
  return response.data;
}, function (error) {
  //Toast.open('请求异常');
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.prototype.$ajax = instance;


Vue.config.productionTip = false;    //Vue.config   虽然没有高亮,但是有值

sync(store, router);

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', () => {
    FastClick.attach(document.body);
  }, false)
}




function init(){
  require('./assets/components/toast/toast-min');
  require('./assets/components/alert/alert-min.js')
}

domOnLoad(init);





router.beforeEach((to, from, next) => {

    next()

});


router.afterEach((to, from) => {
  document.title = to.meta.title || to.params.title || to.query.title
});




new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js